import classNames from "classnames";
import { THEMES } from "../../../constants/constants";
import { saveTheme } from "../../../redux/_actions/settings.action";
import { useAppDispatch, useAppSelector } from "../../../services/hooks.service";
import { setCurrentThemeToLocalStorage } from "../../../services/localStorage.service";
import ThemesStyle from "./ThemesToggler.module.scss";

export const ThemesToggler = () => {
  const dispatch = useAppDispatch();
  const settings = useAppSelector((state) => state.settings);

  const handleThemeChange = (e) => {
    if(e.target.id){
      setCurrentThemeToLocalStorage(e.target.id);
      dispatch(saveTheme(e.target.id));
    }
  }

  const createThemes = () => {
    return THEMES.map((el) => {
      if (settings[el].active) {
      return (
        <button id={el} key={el} className={classNames(ThemesStyle.item, {[ThemesStyle.item_active]: (el === settings.currentTheme)})}>
          {settings[el].name}
        </button>)}
    })
  }

  return (
    <div className={ThemesStyle.container_themes} onClick={handleThemeChange}>
      {createThemes()}
    </div>
  );
};
